import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Patterns() {
  const benchmark = [{
    name: 'Firmas Legales',
    score: '35 - 45',
    width: '40%'
  }, {
    name: 'Logística',
    score: '38 - 48',
    width: '43%'
  }, {
    name: 'Comercio Exterior',
    score: '38 - 46',
    width: '42%'
  }, {
    name: 'Consultoría',
    score: '42 - 52',
    width: '47%'
  }, {
    name: 'Servicios Profesionales',
    score: '40 - 50',
    width: '45%'
  }];
  const patterns = [{
    sector: 'FIRMA LEGAL',
    severity: 'Alta',
    severityColor: '#E85555',
    severityWidth: '30%',
    items: ['El sitio web no comunica la propuesta de valor en los primeros 3 segundos', 'El sitio web no se diferencia de otras firmas del sector', 'Sin credenciales ni prueba social visible'],
    impact: 'Las firmas con este patrón reportan dificultades para convertir búsquedas directas en consultas.'
  }, {
    sector: 'EMPRESA LOGÍSTICA',
    severity: 'Alta',
    severityColor: '#E85555',
    severityWidth: '30%',
    items: ['El sitio web no diferencia los servicios de los competidores', 'Sin contacto visible en dispositivos móviles', 'El sitio web carga en más de 4 segundos'],
    impact: 'Las empresas con este patrón pierden solicitudes de cotización ante competidores con mejor experiencia digital.'
  }, {
    sector: 'CONSULTORÍA',
    severity: 'Media',
    severityColor: '#E8A855',
    severityWidth: '55%',
    items: ['El sitio web no comunica la experiencia del equipo visualmente', 'Sin casos ni resultados documentados', 'El sitio web no explica el proceso de trabajo'],
    impact: 'Las consultoras con este patrón son percibidas como genéricas, reduciendo su capacidad de cobrar tarifas premium.'
  }];
  return <section className="bg-arena py-[72px] md:py-[120px]" data-id="element-294">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-295">
        {/* NIVEL 1 — Header */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16" data-id="element-296">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-297">
            LO QUE ENCONTRAMOS EN LOS SITIOS WEB B2B
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1] max-w-[560px] mb-4" data-id="element-298">
            Los mismos problemas en los sitios web.
            <br data-id="element-299" />
            Sectores distintos.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-carbon/60 leading-[1.6] max-w-[560px] mb-4" data-id="element-300">
            Después de analizar sitios web de empresas B2B en Colombia,
            encontramos los mismos problemas críticos repetidos en cada sector.
          </p>
          <p className="font-body text-[13px] text-carbon/40 italic" data-id="element-301">
            Los análisis a continuación son representativos de patrones
            detectados en el sector. No corresponden a empresas específicas
            identificables.
          </p>
        </motion.div>

        {/* NIVEL 2 — Benchmark sectorial */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16 md:mb-20 bg-arena-dark border border-salvia/25 rounded-[12px] p-8 md:p-10" data-id="element-302">
          <h3 className="font-display text-[24px] md:text-[28px] font-bold text-carbon mb-2" data-id="element-303">
            ¿Cómo están los sitios web de tu sector?
          </h3>
          <p className="font-body text-[15px] text-carbon/55 mb-8" data-id="element-304">
            Puntuación promedio de los sitios web analizados por sector
          </p>
          <div className="space-y-4" data-id="element-305">
            {benchmark.map((row, idx) => <div key={idx} className="grid grid-cols-[180px_1fr_64px] md:grid-cols-[220px_1fr_80px] items-center gap-4" data-id="element-306">
                <span className="font-body text-[13px] md:text-[14px] font-medium text-carbon" data-id="element-307">
                  {row.name}
                </span>
                <div className="h-[6px] w-full bg-[#214D43]/10 rounded-[3px] overflow-hidden" data-id="element-308">
                  <div className="h-full bg-[#214D43] rounded-[3px]" style={{
                width: row.width
              }} data-id="element-309" />
                </div>
                <span className="font-body text-[14px] font-semibold text-azul text-right whitespace-nowrap" data-id="element-310">
                  {row.score}
                </span>
              </div>)}
          </div>
          <p className="font-body text-[12px] text-carbon/40 italic mt-6" data-id="element-311">
            Basado en análisis exploratorios del mercado colombiano. Los datos
            son referenciales.
          </p>
        </motion.div>

        {/* NIVEL 3 — Cards sectoriales */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-312">
          {patterns.map((pattern, idx) => <motion.div key={idx} className="bg-arena-dark border border-salvia/25 rounded-[12px] p-6 md:p-10 hover:bg-arena-darker hover:-translate-y-[2px] hover:shadow-card hover:border-verde/50 transition-all duration-200" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.1
        }} data-id="element-313">
              <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-1" data-id="element-314">
                PATRÓN — {pattern.sector}
              </span>
              <p className="font-body text-[12px] text-carbon/35 mb-5" data-id="element-315">
                Análisis de sitio web B2B · Colombia
              </p>

              <div className="h-px w-full bg-carbon/10 mb-5" data-id="element-316"></div>

              <div className="mb-6" data-id="element-317">
                <span className="block font-body text-[12px] uppercase text-carbon/50 mb-2" data-id="element-318">
                  Brecha detectada
                </span>
                <div className="flex items-center gap-3" data-id="element-319">
                  <div className="h-1.5 flex-grow bg-carbon/10 rounded-full overflow-hidden" data-id="element-320">
                    <div className="h-full rounded-full" style={{
                  width: pattern.severityWidth,
                  backgroundColor: pattern.severityColor
                }} data-id="element-321"></div>
                  </div>
                  <span className="font-body text-[13px] font-semibold text-carbon" data-id="element-322">
                    {pattern.severity}
                  </span>
                </div>
              </div>

              <div className="mb-6 space-y-3" data-id="element-323">
                {pattern.items.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-324">
                    <span className="text-carbon/60 mt-0.5" data-id="element-325">→</span>
                    <p className="font-body text-[14px] font-normal text-carbon/60 leading-[1.6]" data-id="element-326">
                      {item}
                    </p>
                  </div>)}
              </div>

              <div className="h-px w-full bg-carbon/10 mb-5" data-id="element-327"></div>

              <div data-id="element-328">
                <span className="block font-body text-[12px] uppercase text-carbon/50 mb-2" data-id="element-329">
                  Impacto comercial estimado:
                </span>
                <p className="font-body text-[14px] font-normal text-carbon/60 leading-[1.6]" data-id="element-330">
                  {pattern.impact}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* NIVEL 4 — CTA intermedio */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mt-[48px] mx-auto bg-[#EFECE4] border border-salvia/25 rounded-[12px] px-8 md:px-10 py-8 max-w-[720px] flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-id="element-331">
          <div data-id="element-332">
            <h3 className="font-display text-[20px] font-bold text-carbon mb-1" data-id="element-333">
              ¿Tu sitio web tiene alguno de estos problemas?
            </h3>
            <p className="font-body text-[14px] text-carbon/55" data-id="element-334">
              El diagnóstico ICD™ identifica exactamente qué está fallando en
              tu sitio web.
            </p>
          </div>
          <Link to="/diagnostico" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[14px] px-7 py-3.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200 flex-shrink-0" data-id="element-335">
            Ver cómo evaluamos tu sitio{' '}
            <ArrowRight size={16} className="ml-2" data-id="element-336" />
          </Link>
        </motion.div>
      </div>
    </section>;
}